import { Accordion } from '@chakra-ui/react/accordion'
import { Box } from '@chakra-ui/react/box'
import { Text } from '@chakra-ui/react/text'
import { observer } from 'mobx-react-lite'

import classes from './styles.module.css'

import { RULES_PDF_URL } from '../../constants'
import { ExternalLink } from '../ExternalLink'

export const ConditionsAccordion = observer(
  ({ disabled }: { disabled?: boolean }) => {
    return (
      <Accordion.Root collapsible variant="plain" className={classes.root}>
        <Accordion.Item value="conditions" className={classes.item}>
          <Accordion.ItemTrigger
            className={`${classes.trigger}${disabled ? ` ${classes.triggerDisabled}` : ''}`}
          >
            <Text className={classes.title}>Условия</Text>
            <Accordion.ItemIndicator />
          </Accordion.ItemTrigger>
          <Accordion.ItemContent>
            <Box className={classes.contentBox}>
              <Text className={classes.contentText}>
                Чтобы принять участие в нашей акции, вам необходимо приобрести
                любой товар из нашей новой коллекции. Каждая покупка дает вам
                шанс выиграть призы, которые мы подготовили специально для вас.
              </Text>

              <Text className={classes.contentText}>
                После покупки сохраните чек и зарегистрируйтесь на нашем сайте,
                указав свои данные. Участие в акции открыто для всех клиентов, и
                чем больше товаров вы купите, тем выше ваши шансы на победу!
              </Text>

              <Text className={classes.contentText}>
                Смотреть{' '}
                <ExternalLink href={RULES_PDF_URL} className={classes.ruleLink}>
                  Правила Акции
                </ExternalLink>
                .
              </Text>
            </Box>
          </Accordion.ItemContent>
        </Accordion.Item>
      </Accordion.Root>
    )
  },
)
